import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../packageCanvas/assets/close-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-cdc85ca2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading-div" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading text-center" }, "Upgrade Your Plan", -1))
const _hoisted_5 = { class: "bubble-div" }
const _hoisted_6 = { class: "payments-div" }
const _hoisted_7 = {
  key: 0,
  class: "external-link-div"
}
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextBubble = _resolveComponent("TextBubble")!
  const _component_PaymentSlot = _resolveComponent("PaymentSlot")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
      }, _hoisted_3),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_TextBubble, { text: "All users have access to a free MiROS account limited to 1 project. If you need to create more projects and sync them on MiROS Cloud, please upgrade your plan. You may be entitled a free upgrade if you have purchased our robot and it is still within the warranty period." })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_PaymentSlot, {
        cost: "$0",
        dotPoints: ['Free for all users.', 'Limited to 1 project.'],
        buttonTitle: _ctx.userSubscription ? 'Cancel Subscription' : 'Free',
        buttonDisabled: !_ctx.userSubscription,
        buttonRed: _ctx.userSubscription,
        onButtonClick: () => _ctx.openCustomerPortal()
      }, null, 8, ["dotPoints", "buttonTitle", "buttonDisabled", "buttonRed", "onButtonClick"]),
      _createVNode(_component_PaymentSlot, {
        cost: "$3.49/m",
        dotPoints: ['$3.49/m every 5 projects.'],
        buttonDisabled: 
        _ctx.userSubscription &&
        _ctx.getSubscriptionQuantity(_ctx.userSubscription) === _ctx.subscriptionCounter
      ,
        buttonTitle: _ctx.getSubscriptionButtonTitle(),
        buttonRed: 
        _ctx.userSubscription &&
        _ctx.getSubscriptionQuantity(_ctx.userSubscription) !== _ctx.subscriptionCounter &&
        _ctx.subscriptionCounter === 0
      ,
        hasCounter: true,
        counter: _ctx.subscriptionCounter,
        setCounter: (count) => _ctx.subscriptionCounter = count,
        counterText: `${
        Math.round(3.49 * _ctx.subscriptionCounter * 100) / 100
      } per month for ${5 * _ctx.subscriptionCounter} extra projects.`,
        onButtonClick: () => _ctx.onSubscriptionButtonPress()
      }, null, 8, ["dotPoints", "buttonDisabled", "buttonTitle", "buttonRed", "counter", "setCounter", "counterText", "onButtonClick"])
    ]),
    (_ctx.stripeExternalLink)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createTextVNode(" If no window opened, click "),
          _createElementVNode("a", {
            href: _ctx.stripeExternalLink,
            target: "_blank"
          }, "here", 8, _hoisted_8),
          _createTextVNode(" to open the payment link in a new window. ")
        ]))
      : _createCommentVNode("", true)
  ], 64))
}